"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ADMIN_TEST_PUSH_DEFAULT_HEADING = exports.ADMIN_TEST_PUSH_DEFAULT_MESSAGE = void 0;
/** Default copy for the admin OneSignal connectivity test push. */
exports.ADMIN_TEST_PUSH_DEFAULT_MESSAGE = 'This is a test notification from Ivy admin.';
exports.ADMIN_TEST_PUSH_DEFAULT_HEADING = 'Ivy Dating';
//# sourceMappingURL=admin-test-push.js.map